const insightsData = [
    {
        insightType: 'WINNING_STREAK',
        insightTypeES: 'RACHA_GANADORAS',
        priority: 6,
        subtitleEN: 'Máx consecutive winning trades',
        subtitleES: 'Máximos ganados consecutivamente',
        descriptionEN: 'Stay tuned of your winning streaks, by being alerted of your positive streaks.',
        descriptionES: 'Mantente al tanto de tus rachas ganadoras, siendo alertado de tus rachas positivas.',
        color: '#00a553',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Positive-Streak-Swiset.png'
    },
    {
        insightType: 'LOSING_STREAK',
        insightTypeES: 'RACHA_FALLIDAS',
        priority: 7,
        subtitleEN: 'Máx consecutive losing trades',
        subtitleES: 'Máximos perdidos consecutivamente',
        descriptionEN: 'Stay tuned of your losing streaks, by being alerted of your negative streaks.',
        descriptionES: 'Mantente al tanto de tus rachas de fallidas, siendo alertado de tus rachas negativas.',
        color: '#FF4747',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Negative-Streak-Swiset.png'
    },
    {
        insightType: 'MOST_FREQUENT_TRADE_CLOSING_TIME',
        insightTypeES: 'TIEMPO_MÁS_FRECUENTE_DE_CIERRE',
        priority: 9,
        subtitleEN: 'Are the best day hours for winning',
        subtitleES: 'Son las mejores horas del día para ganar',
        descriptionEN: 'Enhance your trading time, by being alerted of your best/worst hours for trading.',
        descriptionES: 'Date cuenta del mejor tiempo para operar, siendo alertado de tus mejores/peores horas de trading.',
        color: '#0092DD',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Most-Frequent-Time-Swiset.png'
    },
    {
        insightType: 'MILESTONE_TRADE',
        insightTypeES: 'HITOS_DE_TRADES',
        priority: 12,
        subtitleEN: 'Are you total trades',
        subtitleES: 'Han sido todos tus trades',
        descriptionEN: 'Stay tuned of your records, being recognized by milestones.',
        descriptionES: 'Mantente al tanto de tus records, siendo reconocido por hitos.',
        color: '#0092DD',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Neutral-Streak-Swiset.png'
    },
    {
        insightType: 'BEST_NET_PROFIT',
        insightTypeES: 'MEJOR_TRADE',
        priority: 5,
        subtitleEN: 'Was the best profit ever',
        subtitleES: 'Has sido la mejor ganancia histórica',
        descriptionEN: 'Stay tuned of your best trades and best profits.',
        descriptionES: 'Mantente al tanto de tus mejores trades y mejores beneficios.',
        color: '#00a553',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Best-Net-Profit-Swiset.png'
    },
    {
        insightType: 'BEST_TRADE_RISK_REWARD',
        insightTypeES: 'MEJOR_TRADE_RISK_REWARD',
        priority: 11,
        subtitleEN: 'Is the best Risk/Reward ever',
        subtitleES: 'Ha sido el mejor Riesgo/Beneficio',
        descriptionEN: 'Stay tuned of the best Risk/Reward of any trade.',
        descriptionES: 'Mantente al tanto de tu mejor Riesgo/Beneficio en algún trade.',
        color: '#0092DD',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Ratios-of-Swiset.png'
    },
    {
        insightType: 'CONSECUTIVE_SIDE',
        insightTypeES: 'LADO_CONSECUTIVO',
        priority: 10,
        subtitleEN: 'Is your side streak',
        subtitleES: 'Es tu racha actual de lado',
        descriptionEN: 'Stay tuned of your buy(long) or sell(short) streaks.',
        descriptionES: 'Mantente al tanto de tus rachas de compras(largos) o ventas(cortos).',
        color: '#0092DD',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Sides-Insights-Swiset.png'
    },
    {
        insightType: 'MONETARY_RISK_EXCEEDED',
        insightTypeES: 'RIESGO_MONETARIO_EXCEDIDO',
        priority: 8,
        subtitleEN: 'Is your average in the last trades',
        subtitleES: 'Es tu promedio en los últimos trades',
        descriptionEN: 'Improve your risk consistency, by being alerted of the risk anomalies.',
        descriptionES: 'Mejora tu consistencia de riesgo, siendo alertado por anomalías en riesgos asumidos.',
        color: '#ffb25f',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Warning-Insight-Swiset.png'
    },
    {
        insightType: 'PERFORMANCE_BY_MOODS',
        insightTypeES: 'RENDIMIENTO_POR_SENTIMIENTO',
        priority: 4,
        subtitleEN: 'Is your most winning mood',
        subtitleES: 'Es tu sentimiento más ganador',
        descriptionEN: 'Stay tuned of the most profitable/winning mood.',
        descriptionES: 'Mantente al tanto de tus sentimientos más rentables/ganadores.',
        color: '#00a553',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Best-Mood-Swiset.png'
    },
    {
        insightType: 'PERFORMANCE_BY_STRATEGIES',
        insightTypeES: 'RENDIMIENTO_POR_ESTRATEGIA',
        priority: 1,
        subtitleEN: 'Is your most winning strategy',
        subtitleES: 'Es tu estrategia más ganadora',
        descriptionEN: 'Stay tuned of the most profitable/winning strategy.',
        descriptionES: 'Mantente al tanto de tus estrategias más rentables/ganadoras.',
        color: '#00a553',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Best-Strategy-Swiset.png'
    },
    {
        insightType: 'PERFORMANCE_BY_DAYS',
        insightTypeES: 'RENDIMIENTO_POR_DÍAS',
        priority: 3,
        subtitleEN: 'Is your most winning day of week',
        subtitleES: 'Es tu día de la semana más ganador',
        descriptionEN: 'Stay tuned of the most profitable/winning day of week.',
        descriptionES: 'Mantente al tanto de tus días más rentables/ganadores.',
        color: '#00a553',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Best-day-Swiset.png'
    },
    {
        insightType: 'PERFORMANCE_BY_STRATEGY_AND_ASSET',
        insightTypeES: 'RENDIMIENTO_POR_ESTRATEGIA_Y_ACTIVO',
        priority: 2,
        subtitleEN: 'Is your most winning strategy/asset',
        subtitleES: 'Es tu estrategia/activo más ganador',
        descriptionEN: 'Stay tuned of the most profitable/winning set of strategy and asset.',
        descriptionES: 'Mantente al tanto de tus conjuntos de estrategias y activos más rentables/ganadores.',
        color: '#00a553',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Best-Asset-Swiset.png'
    },
    {
        insightType: 'CONSISTENCY_RULE',
        insightTypeES: 'REGLA_DE_CONSISTENCIA',
        priority: 13,
        subtitleEN: 'Is the 30% of your positive profit',
        subtitleES: 'Representa el 30% de tus trades positivos',
        descriptionEN: 'Be a consistent trader, by being alerted of the non-consistency patterns.',
        descriptionES: 'Sé un trader consistente, siendo alertado de patrones no consistentes en tu operativa.',
        color: '#0092DD',
        imageUrl: 'https://swiset.com/wp-content/uploads/2021/02/Consistency-Insight-Swiset.png'
    },
];

export default insightsData;
